const updateFormOutlineLayout = ($formOutline) => {
    if (!$formOutline?.length) {
        return;
    }

    window.requestAnimationFrame(() => {
        if (typeof mdb !== 'undefined' && mdb.Input) {
            const instance = mdb.Input.getInstance($formOutline[0]);
            if (instance) {
                instance.update();
            }
        }
    });
}

const handleErrorPlacement = (error, element) => {
    const $element = $(element);
    const $outerContainer = $element.closest('div[id*="Container-"][id$="-fieldSet"]');
    const $fieldSet = $element.closest('div[id$="-fieldSet"], .form-outline.form-group');

    const getOrCreateFormHelper = ($container, insertCallback) => {
        let $helper = $container.children('.form-helper').first();
        const existed = $helper.length > 0;

        if (!existed) {
            $helper = $('<div class="form-helper"></div>');
            insertCallback($helper);
        }

        return { $helper, existed };
    };

    // Container case: element is inside a container but does NOT have its own form-group wrapper
    // (e.g. checkboxQuestionAfter, checkboxLongQuestionAfter, radioLongQuestionAfter)
    // Error goes to the right / inline
    if (
        $outerContainer.length &&
        $fieldSet.length &&
        !$outerContainer.is($fieldSet) &&
        !$fieldSet.hasClass('form-group')
    ) {
        const $lastChildFieldSet = $outerContainer.children('div[id$="-fieldSet"]').last();

        // last sibling is another form input group, place error right after this fieldSet
        if (
            !$lastChildFieldSet.is($fieldSet) &&
            $lastChildFieldSet.is('div.form-group.form-outline')
        ) {
            error.addClass('me-3');
            error.insertAfter($fieldSet);
        } else {
            // element is last: place error at end of outer container
            $outerContainer.append(error);
        }

        return;
    }

    // Check if element is inside a form-check-inline (radio/checkbox inline) — error stays to the right
    if ($element.closest('.form-check-inline').length) {
        $fieldSet.append(error);
        return;
    }

    // Check if fieldSet is inside a form-inline container WITHOUT superstack — error to the right
    // (e.g. signature fields in eSigContainerInner)
    if ($fieldSet.length && $fieldSet.hasClass('form-group')) {
        const $formInlineParent = $fieldSet.parent().closest('.form-inline');

        if (
            $formInlineParent.length &&
            !$formInlineParent.closest('.superstack').length
        ) {
            error.addClass('me-3');
            error.insertAfter($fieldSet);
            return;
        }
    }

    // Regular case: place error underneath the input wrapped in form-helper
    const $formOutline = $element.closest('div.form-outline');

    if ($fieldSet.length) {
        if ($formOutline.length) {
            if (!$formOutline.is($fieldSet)) {
                // form-outline is nested inside fieldSet — place error after form-outline (still inside fieldSet)
                const { $helper, existed } = getOrCreateFormHelper(
                    $fieldSet,
                    ($helper) => $helper.insertAfter($formOutline)
                );

                $helper.prepend(error);
                updateFormOutlineLayout($formOutline);
                return;
            }

            // fieldSet IS the form-outline — place after notch so label is below outlined border
            const $formNotch = $fieldSet.children('.form-notch');

            const { $helper, existed } = getOrCreateFormHelper(
                $fieldSet,
                ($helper) => {
                    if ($formNotch.length) {
                        $helper.insertAfter($formNotch);
                    } else {
                        $fieldSet.append($helper);
                    }
                }
            );

            $helper.prepend(error);
            updateFormOutlineLayout($fieldSet);
            return;
        }

        // fieldSet without form-outline
        const { $helper, existed } = getOrCreateFormHelper(
            $fieldSet,
            ($helper) => $fieldSet.append($helper)
        );

        $helper.prepend(error);
        return;
    }

    if ($formOutline.length) {
        // No fieldSet but inside a form-outline — place after the form-outline
        const { $helper, existed } = getOrCreateFormHelper(
            $formOutline,
            ($helper) => $helper.insertAfter($formOutline)
        );

        $helper.prepend(error);
        updateFormOutlineLayout($formOutline);
        return;
    }

    // Fallback: no fieldSet or form-outline
    const $wrapper = $('<div class="form-helper"></div>');

    $wrapper.append(error);
    $wrapper.insertAfter(element);
}

const hasEffectiveInputValue = (input) => {
    if (!input) {
        return false;
    }

    const value = (input.value || '').trim();
    if (value.length > 0) {
        return true;
    }

    if (!input.inputmask) {
        return false;
    }

    try {
        const unmasked = input.inputmask.unmaskedvalue() || '';
        return unmasked.length > 0;
    } catch (e) {
        return false;
    }
}

// Bind hover events to add/remove 'active' class for empty inputs that have an input mask applied
const bindActiveHoverForEmptyInput = (inputSelectorOrElement) => {
    const selector = typeof inputSelectorOrElement === 'string'
        ? inputSelectorOrElement
        : inputSelectorOrElement?.selector;

    if (!selector) {
        return;
    }

    document.querySelectorAll(selector).forEach((input) => {
        input.addEventListener('mouseenter', function() {
            if (!hasEffectiveInputValue(this)) {
                this.classList.add('active');
            }
        });
        input.addEventListener('mouseleave', function() {
            if (!hasEffectiveInputValue(this)) {
                this.classList.remove('active');
            }
        });
    });
}